import { render } from "./SupplierDialog.vue?vue&type=template&id=0d2f8979&scoped=true"
import script from "./SupplierDialog.vue?vue&type=script&lang=js"
export * from "./SupplierDialog.vue?vue&type=script&lang=js"

import "./SupplierDialog.vue?vue&type=style&index=0&id=0d2f8979&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2f8979"]])

export default __exports__